import { render, staticRenderFns } from "./curacao.vue?vue&type=template&id=31e300ba&scoped=true"
import script from "./curacao.vue?vue&type=script&lang=js"
export * from "./curacao.vue?vue&type=script&lang=js"
import style0 from "./curacao.vue?vue&type=style&index=0&id=31e300ba&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e300ba",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/curacao.vue
// module id = 7L7/
// module chunks = 0